import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const Tag = (props) => {
  const hasAction = !!props.onClick;

  if (hasAction) {
    return (
      <div>
        <div className="inline-flex items-center max-w-full rounded-full h-12 pl-2.8 pr-1 mt-0.8 border border-black">
          <div className="text-base text-gray-900 truncate">
            {props.children}
          </div>
          <ButtonWithIcon
            isIcon
            isSecondary
            icon="close"
            iconWidth="15"
            iconHeight="20"
            onClick={props.onClick}
            disabled={props.disabled}
          />
        </div>
      </div>
    );
    // eslint-disable-next-line no-else-return
  } else {
    return (
      <div className="Tag">
        <div className="label">{props.children}</div>
      </div>
    );
  }
};

Tag.defaultProps = {
  disabled: false,
  onClick: () => {},
};

Tag.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Tag;
